export const GroupType = {
    COMMON: 1,
    STOREY: 2,
    ROOM: 3,
    ELEVATOR: 4,
    FIRE_CONTROL_ROOM: 5,
    PUMP_ROOM: 6,
    GROUP: 7
}